export default "__VITE_ASSET__BEy3muPQ__"